<template>
<div class="qrFindError"> 
    <!-- <div class="header">
         <img src="../../image/back.png" class="back" @click="back"/>
      <div class="imgBox"><img src="../../image/logo-m.png" alt=""></div>
    </div> -->
    <header-top></header-top>
  <div class="error_text">
      <!--<p>抱歉,<span>扫码失败!</span></p>
      <span>失败原因：设备有问题。</span>
      <div>解决方案：请联系客服!</div>-->
      <img src="../../image/error1.png" alt="错误"  />
      <p>{{$t('qrFindError.deviceError')}} <u @click="toPlat">{{$t('qrFindError.toPlat')}}</u> ！</p>
  </div>
</div>
</template>
<script>
import headerTop from "../../components/header.vue";
export default {
  name: "qrFindError",
  data() {
    return {};
  },
  created(){    
  },
  components: {
    headerTop
  },
  mounted(){
      setTimeout(() => {
          this.$router.push('/login');
      }, 3000);
  },
  methods:{
      back:function(){
          this.$router.back(-1);
      },
      toPlat(){
           this.$router.push('/login');
      }
  }
};
</script>
<style scoped>
.findPetInfo{
    width: 100%;
}
/*.error_text{
    width: 18rem;
    margin: 0 auto;
    margin-top: 2rem;
    font-size: 1.5rem;
    color: #666666;
    line-height: 2.8rem;
    box-sizing: border-box;
    padding: 1rem;
    border: 1px;
    box-shadow: 0 0px 15px #38AAFF;
    border-radius: 8px;
}
.error_text p span{
    color: red;
    font-size: 1.8rem;
    font-weight: bold;
}*/
.error_text {
    width: 100%;
    box-sizing: border-box;
    padding: 0 1rem;
    text-align: center;
    margin-top: 10rem;
}
.error_text img{
    width: 3rem;
}
.error_text p{
    font-size: .8rem;
    line-height: 3rem;
}
</style> 


// WEBPACK FOOTER //
// src/m_page/finder/qrFindError.vue